export default "/_next/static/media/SourceSansProSemiBold.723adbf7ee34144bfc0f9699ee09e077.woff2";